// import React, { useEffect, useRef } from "react";
// import * as d3 from "d3";

// const LineChart = ({ rawData }) => {
//   const svgRef = useRef();

//   useEffect(() => {
//     if (!rawData?.data) return;

//     const parsedData = JSON.parse(rawData.data);
//     let data = Object.entries(parsedData).map(([year, value]) => ({
//       year: +year, // Convert year to number
//       value: parseFloat(value), // Ensure 2 decimal places
//     }));

//     if (data.length === 1) {
//       data.unshift({ year: data[0].year - 1, value: 0 });
//     }

//     const width = 270;
//     const height = 200;
//     const margin = { top: 20, right: 20, bottom: 40, left: 40 };

//     const svg = d3.select(svgRef.current)
//       .attr("width", width)
//       .attr("height", height)
//       .style("max-width", "300px")
//       .style("min-width", "300px")
//       .style("height", "200");

//     svg.selectAll("*").remove();

//     const x = d3.scaleLinear()
//       .domain(d3.extent(data, d => d.year))
//       .range([margin.left, width - margin.right]);

//     const maxValue = d3.max(data, d => d.value) || 1; // Ensure a valid maxValue

//     const y = d3.scaleLinear()
//       .domain([0, maxValue])
//       .range([height - margin.bottom, margin.top])
//       .nice(); // Ensure proper tick spacing

//     // Generate unique tick values dynamically
//     const tickValues = maxValue > 1 ? [...new Set(y.ticks(5))] : [0, maxValue];

//     // Draw horizontal grid lines
//     tickValues.forEach(tick => {
//       svg.append("line")
//         .attr("x1", margin.left)
//         .attr("x2", width - margin.right)
//         .attr("y1", y(tick))
//         .attr("y2", y(tick))
//         .attr("stroke", "#ccc")
//         .attr("stroke-width", 0.5);
//     });

//     // X-axis
//     svg.append("g")
//       .attr("transform", `translate(0,${height - margin.bottom})`)
//       .call(d3.axisBottom(x).ticks(5).tickFormat(d3.format("d")));

//     // Y-axis
//     svg.append("g")
//       .attr("transform", `translate(${margin.left},0)`)
//       .call(
//         d3.axisLeft(y)
//           .tickValues(tickValues) // Use filtered unique tick values
//           .tickFormat(d => {
//             if (rawData.dataType === "percentage") {
//               return d.toFixed(1) + "%";
//             } else if (rawData.dataType === "float") {
//               return d.toFixed(1);
//             } else if (rawData.dataType === "integer") {
//               return Math.round(d);
//             } else {
//               return d;
//             }
//           })
//       );

//     if (maxValue > 0) {
//       // Area fill
//       svg.append("path")
//         .datum(data)
//         .attr("fill", "#9ECC3B")
//         .attr("stroke", "steelblue")
//         .attr("stroke-width", 1.5)
//         .attr("opacity", 0.3)
//         .attr("d", d3.area()
//           .x(d => x(d.year))
//           .y0(y(0))
//           .y1(d => y(d.value))
//         );

//       // Line chart
//       svg.append("path")
//         .datum(data)
//         .attr("fill", "none")
//         .attr("stroke", "#9ECC3B")
//         .attr("stroke-width", 2)
//         .attr("d", d3.line()
//           .x(d => x(d.year))
//           .y(d => y(d.value))
//         );

//       // Data points (dots)
//       svg.selectAll(".dot")
//         .data(data)
//         .enter()
//         .append("circle")
//         .attr("cx", d => x(d.year))
//         .attr("cy", d => y(d.value))
//         .attr("r", 4)
//         .attr("fill", "#36baee");

//       // Labels for data points
//       svg.selectAll(".text")
//         .data(data)
//         .enter()
//         .append("text")
//         .filter(d => !(d.year === data[0].year && d.value === 0))
//         .attr("x", d => x(d.year) + 5)
//         .attr("y", d => y(d.value) - 5)
//         // .text(d => Number(d.value).toFixed(2))
//         .text(d => {
//           if (rawData.dataType === "percentage") {
//             return d.value.toFixed(0) + "%";
//           } else if (rawData.dataType === "float") {
//             return d.value.toFixed(1);
//           } else if (rawData.dataType === "integer") {
//             return Math.round(d.value);
//           } else {
//             return d.value;
//           }
//         })
//         .attr("font-size", "12px")
//         .attr("fill", "#1d1d1d");

//     } else {
//       // Show red dots along x-axis if all values are 0
//       svg.selectAll("circle")
//         .data(data)
//         .enter()
//         .append("circle")
//         .attr("cx", d => x(d.year))
//         .attr("cy", y(0))
//         .attr("r", 3)
//         .attr("fill", "steelblue");
//     }

//   }, [rawData]);

//   return <svg ref={svgRef}></svg>;
// };



// const LineChart = ({ rawData }) => {
//   const svgRef = useRef();

//   useEffect(() => {
//     if (!rawData?.data) return;

//     const parsedData = JSON.parse(rawData.data);
//     let data = Object.entries(parsedData).map(([year, value]) => ({
//       year: +year, // Convert year to number
//       value: parseFloat(value), // Ensure 2 decimal places
//     }));

//     if (data.length === 1) {
//       data.unshift({ year: data[0].year - 1, value: 0 });
//     }

//     const width = 270;
//     // const width = 240;
//     const height = 200;
//     const margin = { top: 20, right: 20, bottom: 40, left: 40 };

//     const svg = d3.select(svgRef.current)
//       .attr("width", width)
//       .attr("height", height)
//       // .style("max-width", "250px")
//       .style("max-width", "300px")
//       .style("min-width", "300px")
//       .style("height", "200");

//     svg.selectAll("*").remove();

//     const x = d3.scaleLinear()
//       .domain(d3.extent(data, d => d.year))
//       .range([margin.left, width - margin.right]);

//     const maxValue = d3.max(data, d => d.value);
//     const y = d3.scaleLinear()
//       .domain([0, maxValue > 0 ? maxValue : 1]) // Prevents Y-axis collapse
//       .nice()
//       .range([height - margin.bottom, margin.top]);

//     // Generate Y-axis ticks
//     const yTicks = y.ticks(5);

//     // Draw horizontal grid lines
//     yTicks.forEach(tick => {
//       svg.append("line")
//         .attr("x1", margin.left)
//         .attr("x2", width - margin.right)
//         .attr("y1", y(tick))
//         .attr("y2", y(tick))
//         .attr("stroke", "#ccc")
//         .attr("stroke-width", 0.5);
//     });

//     // X-axis
//     svg.append("g")
//       .attr("transform", `translate(0,${height - margin.bottom})`)
//       .call(d3.axisBottom(x).ticks(5).tickFormat(d3.format("d")));

//     // Y-axis
//     svg.append("g")
//       .attr("transform", `translate(${margin.left},0)`)
//       // .call(d3.axisLeft(y).ticks(5));
//       .call(
//         d3.axisLeft(y)
//           .ticks(5)
//           .tickFormat(d => {
//             if (rawData.dataType === "percentage") {
//               return d.toFixed(1) + "%";  // Show 1 decimal places + "%"
//             } else if (rawData.dataType === "float") {
//               return d.toFixed(1);  // Show 1 decimal places
//             } else if (rawData.dataType === "integer") {
//               return Math.round(d);  // Show as whole number
//             } else {
//               return d;  // Default case
//             }
//           })
//       );

//     if (maxValue > 0) {
//       // Area fill
//       svg.append("path")
//         .datum(data)
//         .attr("fill", "#9ECC3B")
//         .attr("stroke", "steelblue")
//         .attr("stroke-width", 1.5)
//         .attr("opacity", 0.3)
//         .attr("d", d3.area()
//           .x(d => x(d.year))
//           .y0(y(0))
//           .y1(d => y(d.value))
//         );

//       // Line chart
//       svg.append("path")
//         .datum(data)
//         .attr("fill", "none")
//         .attr("stroke", "#9ECC3B")
//         .attr("stroke-width", 2)
//         .attr("d", d3.line()
//           .x(d => x(d.year))
//           .y(d => y(d.value))
//         );

//       // Data points (dots)
//       svg.selectAll(".dot")
//         .data(data)
//         .enter()
//         .append("circle")
//         .attr("cx", d => x(d.year))
//         .attr("cy", d => y(d.value))
//         .attr("r", 4)
//         .attr("fill", "#36baee");

//       // Labels for data points
//       svg.selectAll(".text")
//         .data(data)
//         .enter()
//         .append("text")
//         .filter(d => !(d.year === data[0].year && d.value === 0))
//         .attr("x", d => x(d.year) + 5)
//         .attr("y", d => y(d.value) - 5)
//         // .text(d => Number(d.value).toFixed(2))
//         .text(d => {
//           if (rawData.dataType === "percentage") {
//             return d.value.toFixed(0) + "%"; // Always show 2 decimal places for percentages
//           } else if (rawData.dataType === "float") {
//             return d.value.toFixed(1); // Ensure 2 decimal places for floats
//           } else if (rawData.dataType === "integer") {
//             return Math.round(d.value); // Round to nearest integer
//           } else {
//             return d.value; // Default case (fallback)
//           }
//         })
//         .attr("font-size", "12px")
//         .attr("fill", "#1d1d1d");

//     } else {
//       // Show red dots along x-axis if all values are 0
//       svg.selectAll("circle")
//         .data(data)
//         .enter()
//         .append("circle")
//         .attr("cx", d => x(d.year))
//         .attr("cy", y(0))
//         .attr("r", 3)
//         .attr("fill", "steelblue");
//     }

//   }, [rawData]);

//   return <svg ref={svgRef}></svg>;
// };


// const LineChart = ({ rawData }) => {
//   const svgRef = useRef();

//   useEffect(() => {
//     if (!rawData?.data) return;

//     const parsedData = JSON.parse(rawData.data);
//     let data = Object.entries(parsedData).map(([year, value]) => ({
//       year: +year, // Convert year to number
//       value: parseFloat(value), // Ensure proper numeric values
//     }));

//     if (data.length === 1) {
//       data.unshift({ year: data[0].year - 1, value: 0 });
//     }

//     const width = 270;
//     const height = 200;
//     const margin = { top: 20, right: 20, bottom: 40, left: 40 };

//     const svg = d3.select(svgRef.current)
//       .attr("width", width)
//       .attr("height", height)
//       .style("max-width", "300px")
//       .style("min-width", "300px")
//       .style("height", "200");

//     svg.selectAll("*").remove();

//     const x = d3.scaleLinear()
//       .domain(d3.extent(data, d => d.year))
//       .range([margin.left, width - margin.right]);

//     const maxValue = d3.max(data, d => d.value) || 1;

//     const y = d3.scaleLinear()
//       .domain([0, maxValue])
//       .range([height - margin.bottom, margin.top])
//       .nice();

//     // **Dynamic Y-axis Tick Values**
//     let tickValues;
//     if (maxValue === 1) {
//       tickValues = [0, 0.2, 0.4, 0.6, 0.8, 1]; // Special case for 0-1 range
//     } else if (maxValue > 1) {
//       tickValues = y.ticks(5);
//     } else {
//       tickValues = [0, maxValue];
//     }

//     // Draw horizontal grid lines
//     tickValues.forEach(tick => {
//       svg.append("line")
//         .attr("x1", margin.left)
//         .attr("x2", width - margin.right)
//         .attr("y1", y(tick))
//         .attr("y2", y(tick))
//         .attr("stroke", "#ccc")
//         .attr("stroke-width", 0.5);
//     });

//     // X-axis
//     svg.append("g")
//       .attr("transform", `translate(0,${height - margin.bottom})`)
//       .call(d3.axisBottom(x).ticks(5).tickFormat(d3.format("d")));

//     // Y-axis
//     svg.append("g")
//       .attr("transform", `translate(${margin.left},0)`)
//       .call(
//         d3.axisLeft(y)
//           .tickValues(tickValues)
//           .tickFormat(d => {

//             if (maxValue === 1) {
//               if (rawData.dataType === "percentage") {
//                 return d.toFixed(1) + "%";
//               } else {
//                 return d;
//               }
//             } else if (rawData.dataType === "percentage") {
//               return d.toFixed(1) + "%";
//             } else if (rawData.dataType === "float") {
//               return d.toFixed(1);
//             } else if (rawData.dataType === "integer") {
//               return Math.round(d);
//             } else {
//               return d;
//             }
//           })
//       );

//     if (maxValue > 0) {
//       // Area fill
//       svg.append("path")
//         .datum(data)
//         .attr("fill", "#9ECC3B")
//         .attr("stroke", "steelblue")
//         .attr("stroke-width", 1.5)
//         .attr("opacity", 0.3)
//         .attr("d", d3.area()
//           .x(d => x(d.year))
//           .y0(y(0))
//           .y1(d => y(d.value))
//         );

//       // Line chart
//       svg.append("path")
//         .datum(data)
//         .attr("fill", "none")
//         .attr("stroke", "#9ECC3B")
//         .attr("stroke-width", 2)
//         .attr("d", d3.line()
//           .x(d => x(d.year))
//           .y(d => y(d.value))
//         );

//       // Data points (dots)
//       svg.selectAll(".dot")
//         .data(data)
//         .enter()
//         .append("circle")
//         .attr("cx", d => x(d.year))
//         .attr("cy", d => y(d.value))
//         .attr("r", 4)
//         .attr("fill", "#36baee");

//       // Labels for data points
//       svg.selectAll(".text")
//         .data(data)
//         .enter()
//         .append("text")
//         .filter(d => !(d.year === data[0].year && d.value === 0))
//         .attr("x", d => x(d.year) + 5)
//         .attr("y", d => y(d.value) - 5)
//         .text(d => {
//           if (rawData.dataType === "percentage") {
//             return d.value.toFixed(1) + "%";
//           } else if (rawData.dataType === "float") {
//             return d.value.toFixed(1);
//           } else if (rawData.dataType === "integer") {
//             return Math.round(d.value);
//           } else {
//             return d.value;
//           }
//         })
//         .attr("font-size", "12px")
//         .attr("fill", "#1d1d1d");

//     } else {
//       // Show red dots along x-axis if all values are 0
//       svg.selectAll("circle")
//         .data(data)
//         .enter()
//         .append("circle")
//         .attr("cx", d => x(d.year))
//         .attr("cy", y(0))
//         .attr("r", 3)
//         .attr("fill", "steelblue");
//     }

//   }, [rawData]);

//   return <svg ref={svgRef}></svg>;
// };



import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const LineChart = ({ rawData, DrawPoints }) => {
  const svgRef = useRef();
  let filterData = (rawData) => {
    if (rawData?.data2) {
      let DrawPointsCopy = DrawPoints ? DrawPoints : 0
      let filterBonus = rawData?.data2.filter((item) => {
        return DrawPointsCopy == +item.key && item
      })
      let formattedData = {};
      filterBonus[0].values.forEach((item) => {
        formattedData[item.value] = parseFloat(item.key);
      });
      return JSON.stringify(formattedData);
    } else {
      let parsedData = JSON.parse(rawData?.data);
      if (rawData.variableName == "raffle entry odds") {
        let DrawPointsCopy = DrawPoints ? DrawPoints : 0
        let filterBonus = parsedData[`${DrawPointsCopy == 0 ? 1 : DrawPointsCopy}`]
        return JSON.stringify(filterBonus);
      } else {
        return `${rawData?.data}`;
      }
    }
  };


  useEffect(() => {
    if (rawData?.data || rawData?.data2) {
      let value = filterData(rawData)
      if (value) {
        let parsedData = JSON.parse(value);
        let data = Object.entries(parsedData).map(([year, value]) => ({
          year: +year,
          value: parseFloat(value),
        }));

        if (data.length === 1) {
          data.unshift({ year: data[0].year - 1, value: 0 });
        }

        const width = 270;
        const height = 200;
        const margin = { top: 20, right: 20, bottom: 40, left: 40 };

        const svg = d3.select(svgRef.current)
          .attr("width", width)
          .attr("height", height)
          .style("max-width", "300px")
          .style("min-width", "300px")
          .style("height", "200");

        svg.selectAll("*").remove();

        const years = [...new Set(data.map(d => d.year))].sort((a, b) => a - b);

        const x = d3.scalePoint()
          .domain(years)
          .range([margin.left, width - margin.right])

        const maxValue = d3.max(data, d => d.value) || 1;

        const y = d3.scaleLinear()
          .domain([0, maxValue])
          .range([height - margin.bottom, margin.top])
          .nice();

        // Dynamic Y-axis ticks
        let tickValues;
        if (maxValue === 1) {
          tickValues = [0, 0.2, 0.4, 0.6, 0.8, 1];
        } else if (maxValue > 1) {
          tickValues = y.ticks(5);
        } else {
          tickValues = [0, maxValue];
        }

        // Grid lines
        tickValues.forEach(tick => {
          svg.append("line")
            .attr("x1", margin.left)
            .attr("x2", width - margin.right)
            .attr("y1", y(tick))
            .attr("y2", y(tick))
            .attr("stroke", "#ccc")
            .attr("stroke-width", 0.5);
        });

        // X-axis
        svg.append("g")
          .attr("transform", `translate(0,${height - margin.bottom})`)
          .call(d3.axisBottom(x).tickFormat(d3.format("d")));

        // Y-axis
        svg.append("g")
          .attr("transform", `translate(${margin.left},0)`)
          .call(
            d3.axisLeft(y)
              .tickValues(tickValues)
              .tickFormat(d => {
                if (rawData.dataType === "percentage") return d.toFixed(1) + "%";
                if (rawData.dataType === "float") return d.toFixed(1);
                if (rawData.dataType === "integer") return Math.round(d);
                return d;
              })
          );

        if (maxValue > 0) {
          // Area fill
          svg.append("path")
            .datum(data)
            .attr("fill", "#9ECC3B")
            .attr("stroke", "steelblue")
            .attr("stroke-width", 1.5)
            .attr("opacity", 0.3)
            .attr("d", d3.area()
              .x(d => x(d.year))
              .y0(y(0))
              .y1(d => y(d.value))
            );

          // Line
          svg.append("path")
            .datum(data)
            .attr("fill", "none")
            .attr("stroke", "#9ECC3B")
            .attr("stroke-width", 2)
            .attr("d", d3.line()
              .x(d => x(d.year))
              .y(d => y(d.value))
            );

          // Dots
          svg.selectAll(".dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("cx", d => x(d.year))
            .attr("cy", d => y(d.value))
            .attr("r", 4)
            .attr("fill", "#589500");

          // Value labels
          svg.selectAll(".text")
            .data(data)
            .enter()
            .append("text")
            .filter(d => !(d.year === data[0].year && d.value === 0))
            .attr("x", d => x(d.year) + 5)
            .attr("y", d => y(d.value) - 5)
            .text(d => {
              if (rawData.dataType === "percentage") return d.value.toFixed(1) + "%";
              if (rawData.dataType === "float") return d.value.toFixed(1);
              if (rawData.dataType === "integer") return Math.round(d.value);
              return d.value;
            })
            .attr("font-size", "12px")
            .attr("fill", "#1d1d1d");

        } else {
          // Red baseline dots if value is 0
          svg.selectAll("circle")
            .data(data)
            .enter()
            .append("circle")
            .attr("cx", d => x(d.year))
            .attr("cy", y(0))
            .attr("r", 3)
            .attr("fill", "steelblue");
        }
      }
    }
  }, [rawData]);

  return <svg ref={svgRef}></svg>;
};

export default LineChart;






